/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Swiper from './../libs/swiper';

$(function(){
    function initShortcodeOfferRankedEvents(){
        let $shortcodes = $('.shortcode-offer-ranked');
        if(!$shortcodes.length){
            return;
        }

        let $swiperContainers = $shortcodes.find('.item-gallery .swiper-container');
        $swiperContainers.each(function () {
            new Swiper($(this)[0], {
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        slidesOffsetAfter: -45,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        slidesOffsetAfter: 0,
                    },
                },
            });
        });
    }

    initShortcodeOfferRankedEvents();
});
